import DynamicForm from '@components/shared-ui-components/DynamicForm'
import { Paper } from '@mui/material'

function ExportPage() {

  return (
    <Paper
      elevation={3} // Add shadow effect
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h4>Please fill up the Export form</h4>
      <DynamicForm page={'export'} />
    </Paper>
  )
}

export default ExportPage